import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT, HOW_IT_WORKS_IDS } from '../../../constants';

import { fetchFaqIfNeeded } from '../../../services/faq/actions';

import { clickEvent } from '../../../utils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';

import YoutubeEmbed from './YoutubeEmbed';
import Breadcrumb from '../../breadcrumb/Breadcrumb';
import HowItWorksComponent from '../../HowItWorksComponent';
import FaqElementComponent from '../faq/FaqElementComponent';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import CustomerServiceComponent from '../../CustomerServiceComponent';

import './HowItWorksPage.scss';

export class HowItWorksPage extends React.Component {
    componentDidMount() {
        this.props.fetchFaqIfNeeded();
    }

    render() {
        const { i18nPage, faqData } = this.props;

        // Currently select the first theme with non empty faq list /!\
        let faqs = [];
        faqData.map(theme => theme.faqs && theme.faqs.map(faq => faqs.push(faq)));
        const filteredFaqs = faqs.filter(f => HOW_IT_WORKS_IDS.includes(f.id));

        return (
            <React.Fragment>
                <main role="main" className="conteneur conteneur-mobile" id="p-cmt-ca-marche">
                    <HeadComponent
                        title={i18nPage.TITLE}
                        description={i18nPage.DESCRIPTION}
                        canonicalLink={`${CONTEXT_ROOT}${PATH.HOW_IT_WORK_PATH}`}
                    />
                    <Breadcrumb
                        defaultRoute
                        routes={[
                            {
                                label: i18nPage.BREADCRUMB,
                                route: PATH.HOW_IT_WORK_PATH
                            }
                        ]}
                    />

                    <h1>{i18nPage.H1}</h1>

                    <div className="ccm-text">
                        <h3>{i18nPage.H31}</h3>
                        <p>{i18nPage.TEXT_1}</p>
                        <h3>{i18nPage.H32}</h3>
                        <p>{i18nPage.TEXT_2}</p>
                        <h3>{i18nPage.H33}</h3>
                        <p>{i18nPage.TEXT_3}</p>
                        <ul>
                            <li>{i18nPage.TEXT_4}</li>
                            <li>{i18nPage.TEXT_5}</li>
                            <li>{i18nPage.TEXT_6}</li>
                        </ul>
                    </div>

                    <hr />

                    <HowItWorksComponent showButtons />

                    <hr />

                    <div className="conteneur-mobile embed-video">
                        <YoutubeEmbed embedId="28HCzjjrT40" width="1024" height="488" />
                    </div>

                    <hr />

                    <div className="help-container grid">
                        <div className="faq-container inbl">
                            <div className="faq-bandeau">
                                <h2>{i18nPage.QUESTION}</h2>
                                <LinkButtonComponent
                                    to={PATH.FAQ_PATH}
                                    title={i18nPage.FREQUENTLY_ASKED_QUESTIONS}
                                    color="main"
                                    text={i18nPage.FREQUENTLY_ASKED_QUESTIONS}
                                    onClick={clickEvent(
                                        'comment_ca_marche_clic_question',
                                        'comment_ca_marche'
                                    )}
                                />
                            </div>
                            <div className="faq-list-container">
                                {filteredFaqs.map(faq => (
                                    <FaqElementComponent
                                        key={faq.id}
                                        faq={faq}
                                        cssClass="question-comment-ca-marche-page"
                                    />
                                ))}
                            </div>
                        </div>

                        <CustomerServiceComponent />
                    </div>
                </main>
            </React.Fragment>
        );
    }
}

HowItWorksPage.propTypes = {
    i18nPage: PropTypes.object.isRequired,
    faqData: PropTypes.array
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        locale: state.i18n.locale,
        i18nPage: state.i18n.page.HOW_IT_WORKS,
        faqData: state.faq.faqs || []
    };
};

const mapDispatchToProps = {
    fetchFaqIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(HowItWorksPage),
    PrimaryTemplate
);



// WEBPACK FOOTER //
// ./src/components/pages/howitworks/HowItWorksPage.js